import { UserAction, userActionTypeEnum } from '@thoughtspot/metrics';
export var HelpMenuItemTrackIds;
(function (HelpMenuItemTrackIds) {
    HelpMenuItemTrackIds["HELP"] = "help";
    HelpMenuItemTrackIds["GETTING_STARTED"] = "getting-started";
    HelpMenuItemTrackIds["WHATS_NEW"] = "whats-new";
    HelpMenuItemTrackIds["ABOUT_INSTANCE"] = "about";
    HelpMenuItemTrackIds["CONTACT_SUPPORT"] = "contact-support";
})(HelpMenuItemTrackIds || (HelpMenuItemTrackIds = {}));
export const trackHelpIconClick = (metricsService) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.TOP_NAV_INFO_CENTER_CLICK), {});
};
export const trackHelpMenuItemClick = (metricsService, trackId) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.CLICK), {
        trackId,
    });
};
export const trackAboutModalShown = (metricsService, instanceInfo) => {
    metricsService.collectEvent(new UserAction(userActionTypeEnum.ABOUT_MODAL_SHOWN), {
        version: instanceInfo.version,
        'cluster-id': instanceInfo.clusterId,
        timezone: instanceInfo.clusterTimezone,
    });
};
//# sourceMappingURL=metrics.util.js.map